import { ButtonLink } from "@ui/ButtonLink";
import { useAppContext } from "@ui/layouts/layoutProvider";
import { Tooltip, TooltipTrigger } from "@ui/Tooltip";
import "./MenuPrimaryActions.css";

type Props = {
	cta: { href: string; label: string; symbol: string };
};

/** Main sidebar CTA (Ask anyone, Upload, …). */
export const MenuPrimaryActions = (props: Props) => {
	const { menuIsOpen } = useAppContext();

	return (
		<div class="menu-primary-actions">
			<TooltipTrigger
				placement="right"
				anchorTo=".side-bar"
				disabled={menuIsOpen()}
			>
				<ButtonLink
					href={props.cta.href}
					variant="primary"
					theme="mint-grad"
					symbol={props.cta.symbol}
					size="large"
					fullWidth
					class="menu-primary-actions__cta"
					aria-label={props.cta.label}
				>
					{props.cta.label}
				</ButtonLink>
				<Tooltip>{props.cta.label}</Tooltip>
			</TooltipTrigger>
		</div>
	);
};
